var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 47,
    viewBox: "0 0 68 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7542L67.6013 0L20.0861 26.2441L0 15.7542Z",
    fill: "#2F5D99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5996 0L52.4864 46L28.0684 30.4595L67.5996 0Z",
    fill: "#2F5D99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0859 26.2441L22.8832 46L28.0699 30.4595L67.6011 0L20.0859 26.2441Z",
    fill: "#234269"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8828 46.0015L37.5686 36.5218L28.0695 30.4609L22.8828 46.0015Z",
    fill: "#19304D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paperPlane.6942621f1f19d0e9ed23b296bc2d5bfb.svg";
export { ForwardRef as ReactComponent };